package pl.decks.personal.pages.ievp.sections.lastyears

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Span

enum class ExuraStoryParagraphs(val content: @Composable () -> Unit) {
    SW_FLAVOUR({
        Span(LastYearsSectionStylesheet.Paragraph.SWIntro.toModifier().toAttrs()) {
            SpanText("A ")
            SpanText("not-so-", Modifier.fontStyle(FontStyle.Italic))
            SpanText("long time ago in a ")
            SpanText("galaxy", Modifier.textDecorationLine(TextDecorationLine.LineThrough))
            SpanText(" country ", Modifier.fontStyle(FontStyle.Italic))
            SpanText("far, far away...")
        }
    }),
    POMPOUS_INTRO({
        Span(LastYearsSectionStylesheet.Paragraph.SWIntro.toModifier().toAttrs()) {
            SpanText("Two colleagues met in seemingly random circumstances. ")
            SpanText("They learned that for a while they had the same urge. ")
            SpanText("A feeling that it is about time to take a risk and create something bigger than just themselves. ")
            SpanText("For the greater good. ")
            SpanText("For fulfilled ambition. ")
            SpanText("For glory...")
        }
    }),
    BREAK ({ }),
    REASONS({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("Well, enough with the jokes and pompous introduction. ")
            SpanText("We really wanted to do something that felt important, both personally and at broader level. ")
            SpanText("We had a complementary skill set and were blissfully unaware of the hurdles we needed to overcome in order to accomplish it.")
        }
    }),
    BUILDER({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("I am a builder and I honestly thought I'd get to build more. ")
            SpanText("Spend my days handling complex technical issues, churning out prototypes and adding new tools to my stack. ")
            SpanText("With time I've got to experience some of it as well, but the effort spent to get to that point was enormous. ")
            SpanText("While there is beauty in creation for its own sake, business-wise you have to focus on things which people want and will pay for.")
        }
    }),
    BUSINESS_MAPS({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("So, we were researching, formulating ideas, validating and reiterating. ")
            SpanText("A lot. ")
            SpanText("Found a myriad of possible combinations of answers to the timeless questions: Who's the user? Whom to partner with? Why would someone pay? What is the proposition? ")
            SpanText("Despite always being on the verge of startup culture and the heavy interest in it, only living the struggle made me understand the real value of the tools it uses to map the space. ")
            SpanText("How important it is to have a common map and vocabulary for discussion.")
        }
    }),
    MISTAKES({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("On the journey we have made wrong assumptions, taken suboptimal paths or entirely wrong turns. ")
            SpanText("We started over or made a significant pivot at least four times. ")
            SpanText("Also, probably burned twice the money we could have if done all over again (but that is still a one tenth the amount an usual non-bootstrapped startup spends before reaching an MVP). ")
            SpanText("I admit my mistakes. ")
            SpanText("I even cherish them and can draw my lessons. ")
            SpanText("Things always go sideways, one way or the other, and I prefer to be there and adjust the course.")
        }
    }),
    THE_FINAL_SHAPE({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("Yet retrospectively, this time is quite a feat. ")
            SpanText("Experience, SWOT analysis, vague ideas, loose observations, values we represent... ")
            SpanText("Everything drew us to healthcare problems and tech solutions. ")
            SpanText("Low compliance and a sense of being lost during a medical process seemed worth tackling. ")
            SpanText("A communication channel designed specifically around medical procedures information turned out to be quite an attractive solution.")
        }
    }),
    ACCOMPLISHMENTS({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("We managed to build a network in a very hermetic environment from the ground up. ")
            SpanText("We signed partnerships, built an audience, earned credibility and recognition. ")
            SpanText("We were finalists in several startup competitions too! ")
            SpanText("We created products and piloted them at client side in a highly regulated market, firsthand experiencing constraints-based development. ")
            SpanText("Delivered a modular system that seamlessly connects a few roles in the process, spans multiple technical domains and is anonymous by design. ")
            SpanText("There is a web application, mobile product, backend infrastructure, a website, socials, publications, blog...")
        }
    }),
    GROWTH({
        Span(LastYearsSectionStylesheet.Paragraph.Text.toModifier().toAttrs()) {
            SpanText("Overall, the path has taken me to corners of personal development I didn't suspect existed. ")
            SpanText("I am a different person now. ")
            SpanText("I have grown in areas that are complementary to my previous strengths. ")
            SpanText("Walked a proverbial mile in my stakeholders' shoes. ")
        }
    }),
    ;
}
